import { render, staticRenderFns } from "./consumer.vue?vue&type=template&id=1a92fb14&"
import script from "./consumer.vue?vue&type=script&lang=ts&"
export * from "./consumer.vue?vue&type=script&lang=ts&"
import style0 from "./consumer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports